export default __webpack_public_path__ + "static/media/2022_November_Wörter.56d49255.webp";